export default __webpack_public_path__ + "static/media/Armwraps of the Reanimator.33c2144b.jpg";